/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Required_AgreementInputs */

const en_label_required_agreement = /** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required Agreement`)
};

const es_label_required_agreement = /** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acuerdo Obligatorio`)
};

const fr_label_required_agreement = /** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accord obligatoire`)
};

const de_label_required_agreement = /** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderliche Vereinbarung`)
};

const id_label_required_agreement = /** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perjanjian Wajib`)
};

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const ja_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const zh_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const ar_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const it_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const ru_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const pt_label_required_agreement = en_label_required_agreement;

/** @type {(inputs: Label_Required_AgreementInputs) => LocalizedString} */
const ko_label_required_agreement = en_label_required_agreement;

/**
* | output |
* | --- |
* | "Required Agreement" |
*
* @param {Label_Required_AgreementInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_required_agreement = /** @type {((inputs?: Label_Required_AgreementInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Required_AgreementInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_required_agreement(inputs)
	if (locale === "es") return es_label_required_agreement(inputs)
	if (locale === "fr") return fr_label_required_agreement(inputs)
	if (locale === "de") return de_label_required_agreement(inputs)
	if (locale === "ja") return ja_label_required_agreement(inputs)
	if (locale === "zh") return zh_label_required_agreement(inputs)
	if (locale === "ar") return ar_label_required_agreement(inputs)
	if (locale === "id") return id_label_required_agreement(inputs)
	if (locale === "it") return it_label_required_agreement(inputs)
	if (locale === "ru") return ru_label_required_agreement(inputs)
	if (locale === "pt") return pt_label_required_agreement(inputs)
	return ko_label_required_agreement(inputs)
});